import { render, staticRenderFns } from "./SubscriberAddress.vue?vue&type=template&id=74384538&scoped=true"
import script from "./SubscriberAddress.vue?vue&type=script&lang=ts"
export * from "./SubscriberAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74384538",
  null
  
)

export default component.exports